import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-quotes"},[_c(VRow,{staticClass:"d-flex justify-center"},[_c('h2',{staticClass:"section-quotes__title"},[_vm._v("Why customers love us")])]),_c('QuoteCarousel')],1)}
var staticRenderFns = []

export { render, staticRenderFns }